import type { ToastEmits, ToastProps } from '../components/AwToast.vue'
import type { EmitsToProps } from '../types/utils'
import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

export interface Toast extends Omit<ToastProps, 'defaultOpen'>, EmitsToProps<ToastEmits> {
  id: string | number
  onClick?: (toast: Toast) => void
}

export const useToast = createSharedComposable(() => {
  const toasts = ref<Toast[]>([])

  function add(notification: Partial<Toast>) {
    const body = {
      id: new Date().getTime().toString(),
      ...notification,
    }
    const index = toasts.value.findIndex((n: Toast) => n.id === body.id)
    if (index === -1)
      toasts.value.push(body as Toast)
    return body
  }

  function remove(id: string | number) {
    toasts.value = toasts.value.filter((n: Toast) => n.id !== id)
  }

  return {
    add,
    toasts,
    remove,
  }
})
